import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './Menu/layout-style.css';
import { useAppSelector } from '@application/store/useStore';
import { Navigate, Outlet } from 'react-router-dom';
import Header from './Header';
import SidebarMenu from './Menu/SidebarMenu';
import { useState } from 'react';
const Layout = () => {
    const { currentUser } = useAppSelector((state) => state.auth);
    const [isMenuVisible, setIsMenuVisible] = useState(true);
    const menuButtonClick = (isClicked) => {
        setIsMenuVisible(!isClicked);
    };
    if (!currentUser)
        return _jsx(Navigate, { to: '/login' });
    return (_jsx("div", { className: 'dashboard-main', children: _jsxs("div", { className: 'dashboard-inner', children: [currentUser ? (_jsxs(_Fragment, { children: [_jsx(SidebarMenu, { userRole: currentUser?.role, isMenuOpen: isMenuVisible }), _jsxs("main", { className: `${isMenuVisible === false ? '' : 'full'}`, children: [_jsx(Header, { currentUser: currentUser, onMenuButtonClick: menuButtonClick }), _jsx(Outlet, {})] })] })) : (_jsx(_Fragment, {})), _jsx("div", {})] }) }));
};
export default Layout;
